import useModuleMetadata from 'src/hooks/use-module-metadata.hook';
import { useState } from 'react';
import { useAppDispatch } from 'src/hooks';
import useMatomoFunction from 'src/hooks/use-matomo-function.hook';
import CustomDownloadButton from 'src/components/buttons/button-with-spinner-v2';
import MODULE_TO_PAGE_MAP from '../../../home/types/simulation-module-to-page-map';
import TemporaryDialog from '../../../common/components/module-save-button/temporary-dialog';
import { downloadSummary } from '../../store/planner-slice-async-thunks';
import { MatomoEventTrackMapObject } from '../../../constants/constant';

interface IDownloadSummaryButtonProps {
  isDisabled: boolean;
}

export default function DownloadSummaryButton({
  isDisabled = false
}: IDownloadSummaryButtonProps) {
  const [isTemporaryDialogOpen, setIsTemporaryDialogOpen] = useState(false);
  const { callFunction } = useMatomoFunction();
  const { moduleId, scenarioId, sourceId } = useModuleMetadata({
    module: MODULE_TO_PAGE_MAP.PLANNER
  });
  const getPageName = () => {
    const page_title = window.location.href.split('/').at(-1);
    return page_title;
  };
  const appDispatch = useAppDispatch();
  const handleDownload = () => {
    // tracking download click event
    callFunction(
      MatomoEventTrackMapObject.track_simulate_button_click.event_key,
      getPageName()
    );

    return appDispatch(downloadSummary({ sourceId, moduleId, scenarioId }))
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.error('Failed to download summary', error);
        setIsTemporaryDialogOpen(true);
      });
  };
  return (
    <>
      <CustomDownloadButton
        disabled={isDisabled}
        onClick={handleDownload}
        buttonText='Download Summary'
      />
      {isTemporaryDialogOpen ? (
        <TemporaryDialog
          isOpen={isTemporaryDialogOpen}
          message='Failed to download summary'
          onClose={() => {
            setIsTemporaryDialogOpen(false);
          }}
        />
      ) : null}
    </>
  );
}
